module.exports = __webpack_public_path__ + "assets/img/Logo (1).67304a9e.png";